import { useDebugValue, useState } from 'react'

export const useModalControl = <T = Record<string, unknown>>(
  modalName?: string,
  initialState = {} as T,
  defaultShown = false,
) => {
  let modalNameUsed = 'ModalControl'
  if (modalName?.length) {
    modalNameUsed = modalName
    if (!modalName.toLowerCase().match('modal')) modalNameUsed += 'Modal'
  }
  useDebugValue(modalNameUsed)
  const [state, setState] = useState<T>(initialState)
  const [shown, setShown] = useState<boolean>(defaultShown)
  const hide = () => {
    setState(initialState)
    setShown(false)
  }
  const show = () => setShown(true)
  const toggle = () => setShown((s) => !!s)
  return { shown, setShown, hide, show, toggle, state, setState }
}
